module.exports = __webpack_public_path__ + "static/files-da223f9a304dac4561d9f2bb20db793d.svg";